<template>
  <div class="container">
    <Modal
      v-model.trim="changeModal"
      :title="title"
      :loading="loading"
      @on-cancel="cancel"
    >
      <Form
        ref="formItem"
        :model="formItem"
        :label-width="130"
        :rules="validateRules"
      >
        <FormItem label="新密码" prop="newPwd">
          <Input v-model.trim="formItem.newPwd" type="password" />
        </FormItem>
        <FormItem label="确认密码" prop="pwdCheck">
          <Input v-model.trim="formItem.pwdCheck" type="password" />
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <Button @click="cancel">取消</Button>
        <Button type="primary" @click="ok()">确认</Button>
      </div>
      <div
        v-if="isShowTips"
        style="
          margin-top: 3px;
          margin-bottom: 10px;
          color: #6ea0ff;
          line-height: normal;
          text-align: center;
        "
      >
        当前为初始密码，请修改密码
      </div>
    </Modal>
  </div>
</template>
<script>
import { changePwd } from '@/api/user';

export default {
  name: 'ChangePasswordModal',
  props: {
    title: {
      type: null,
      default: '修改密码',
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    isShowTips: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.formItem.newPwd !== '' && value === '') {
        callback(new Error('确认密码不能为空！'));
      } else if (this.formItem.newPwd !== value) {
        callback(new Error('新密码和确认密码不一致！'));
      } else {
        callback();
      }
    };
    return {
      validateRules: {
        newPwd: [
          {
            required: true,
            type: 'string',
            message: '新密码不能为空',
            trigger: 'blur',
          },
          {
            required: false,
            pattern: /^(?=.*\d)(?=.*[a-zA-Z]).{6,18}$/,
            message: '密码格式不正确，请输入8-16位字母、数字组合',
            trigger: 'blur',
          },
        ],
        pwdCheck: [
          { required: false, validator: pwdCheckValidate, trigger: 'blur' },
        ],
      },
      loading: true,
      formItem: {
        newPwd: '',
        pwdCheck: '',
      },
      changeModal: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.changeModal = newVal;
    },
  },
  methods: {
    ok() {
      const me = this;
      this.$refs.formItem.validate((valid) => {
        if (valid) {
          changePwd(me.formItem)
            .then((res) => {
              if (res.data.success) {
                me.$message.info('修改密码成功！');
                this.changeModal = false;
                this.$emit('changeModal', this.changeModal);
                this.$emit('okModal', this.changeModal);
                this.formItem = {
                  newPwd: '',
                  pwdCheck: '',
                };
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              console.log('err', err);
            });
        } else {
          this.$message.error('请输入必填项!');
        }
      });
    },
    cancel() {
      this.changeModal = false;
      this.formItem = {
        newPwd: '',
        pwdCheck: '',
      };
      this.$emit('changeModal', this.changeModal);
      this.$emit('cancelModal');
    },
  },
};
</script>
